import { BannerRequestBody } from 'api/Banner/types'
import { getCerebroHeaders } from 'api/Cerebro/headers'
import { CerebroApiOptions, CerebroPaginatedResponse } from 'api/Cerebro/types'
import { orgScopedApiClient } from 'api/orgScopedClient'
import { CountryCode } from 'types'

export interface OrgPerformanceFactsGroupBys {
    marketplace?: CountryCode
    product_id?: string
    product_small_image_url?: string
    product_title?: string
    root_category_id?: string
    root_category_name?: string
    leaf_category_id?: string
    leaf_category_name?: string
    brand?: string
    current_period_date_day?: string
    prior_period_date_day?: string
    yoy_date_day?: string
}

export type BaseOrgPerformanceFactsMetric =
    | 'average_selling_price'
    | 'bb_conversion_rate'
    | 'buy_box_traffic__sum'
    | 'category_revenue__sum'
    | 'competitive_offers_count__avg'
    | 'category_share'
    | 'conversion_rate'
    | 'estimated_search_volume__sum'
    | 'pdp_views__sum'
    | 'rank_weight_pct'
    | 'sales__sum'
    | 'units_ordered__sum'
    | 'ad_sales__sum'
    | 'ad_sales_contribution'
    | 'organic_sales__sum'
    | 'ad_spend__sum'
    | 'tacos'
    | 'troas'
    | 'acos'
    | 'roas'

type OrgPerformanceFactsMetricSuffix =
    | ''
    | '__total'
    | '__prior_period'
    | '__prior_period__total'
    | '__prior_period__change'
    | '__prior_period__percentage_change'
    | '__yoy'
    | '__yoy__total'
    | '__yoy__change'
    | '__yoy__percentage_change'

export type OrgPerformanceFactsMetrics = {
    [M in BaseOrgPerformanceFactsMetric as `${M}${OrgPerformanceFactsMetricSuffix}`]?: number
}

export interface OrgPerformanceFactsRecord
    extends OrgPerformanceFactsGroupBys,
        OrgPerformanceFactsMetrics {
    results_count: number
}

export const getOrgPerformanceFacts = <T extends OrgPerformanceFactsRecord>(
    params: BannerRequestBody,
    options: CerebroApiOptions = {}
): Promise<CerebroPaginatedResponse<T>> =>
    orgScopedApiClient.post<CerebroPaginatedResponse<T>, any>(
        '/api/org_performance_facts/aggregate/banner/',
        params,
        { headers: getCerebroHeaders(options.headers) }
    )
